import { JOURNEY_STATUSES } from '../constants/journeys';
import { JourneyStatus } from '../types/journey';

export const getJourneyStatus = (journeyStatus: JourneyStatus) => {
  return JOURNEY_STATUSES.find((status) => status.type === journeyStatus);
};

export const getNoCommunicationTimeIntervals = () => {
  const minutes: number[] = [];
  for (let m = 5; m <= 60; m += 5) {
    minutes.push(m);
  }
  return minutes;
};
